import { DEFAULT_INPUTS } from '../selectors/footprint';
import * as userAPI from '../../lib/userApi';
import selectors from '../selectors';
import patch from './patch';
import computeAverageFootprint from './computeAverageFootprint';
import { computeUserFootprint } from './computeResults';
import { serializeCalculatorAnswersToState } from '../transformations/calculatorAnswers.ts';

export const intitializeFromToken = token => async (dispatch, getState) => {
  dispatch(patch({ ui: { loadingCalculatorAnswers: true } }));
  try {
    const { body: { user, calculatorAnswers } } = await userAPI.me(token, { include: encodeURIComponent('user,calculatorAnswers') });
    dispatch(patch({ user, accountForm: user }));
    if (calculatorAnswers) {
      dispatch(patch(serializeCalculatorAnswersToState(calculatorAnswers)));
      if (!getState().average_footprint) {
        // this patches older accounts that did not have average footprint saved on server.
        await computeAverageFootprint()(dispatch, getState);
      } else {
        await computeUserFootprint(
          calculatorAnswers.user_footprint.inputs, false,
        )(dispatch, getState);
      }
      return true;
    }
  } catch (_err) {
    // continue to initialization
  }
  dispatch(patch({ ui: { loadingCalculatorAnswers: false }, auth: { token: '' } }));
  return false;
};


/**
 * initialize the application by populating defaults and user footprint
 * with default values. If token is available on store, will retrieve
 * answers and goals from API.
 */
export default () => async (dispatch, getState) => {
  const state = getState();
  let initializedFromToken = false;
  if (selectors.isTokenValid(state)) {
    const token = selectors.token(state);
    initializedFromToken = await intitializeFromToken(token)(dispatch, getState);
  }
  if (!initializedFromToken) {
    try {
      await computeAverageFootprint()(dispatch, getState);
    } catch (err) {
      await computeAverageFootprint(DEFAULT_INPUTS)(dispatch, getState);
    }
  }
};

